import {ShowUsersTariffPlans} from './show-users-tariff-plans';

export default ShowUsersTariffPlans;
